export default "__VITE_ASSET__rh8z6h8D__"